// Section dividers belong to the constructed story, not the spoken transcript.
// Their slots become timeline markers (not media clips) in XML exports.
const maxSlot=paper=>paper.blocks?.length||0;
const slot=(paper,index)=>Math.max(0,Math.min(maxSlot(paper),Math.round(index)));
export function addStorySection(paper,beforeIndex,title='New section',id=()=>crypto.randomUUID()){
  return {...paper,sectionHeadings:[...(paper.sectionHeadings||[]),{id:id(),title,beforeIndex:slot(paper,beforeIndex)}]};
}
export function renameStorySection(paper,id,title){
  const trimmed=String(title||'').trim().slice(0,100);
  if(!trimmed)return paper;
  return {...paper,sectionHeadings:(paper.sectionHeadings||[]).map(s=>s.id===id?{...s,title:trimmed}:s)};
}
export function moveStorySection(paper,id,delta){
  return {...paper,sectionHeadings:(paper.sectionHeadings||[]).map(s=>s.id===id?{...s,beforeIndex:slot(paper,s.beforeIndex+delta)}:s)};
}
export function removeStorySection(paper,id){
  return {...paper,sectionHeadings:(paper.sectionHeadings||[]).filter(s=>s.id!==id)};
}
export function removeStoryPassage(paper,id){
  const index=paper.blocks.findIndex(block=>block.id===id);
  if(index<0)return paper;
  return {...paper,blocks:paper.blocks.filter(b=>b.id!==id),
    sectionHeadings:(paper.sectionHeadings||[]).map(s=>({...s,
      beforeIndex:Math.max(0,s.beforeIndex>index?s.beforeIndex-1:s.beforeIndex)}))};
}
export function sectionsForDraft(draft,blocks,{offset=0,id=()=>crypto.randomUUID()}={}){
  const names={beginning:'Beginning',middle:'Development',end:'Ending'};
  const provided=new Map((draft.sections||[]).map(section=>[section.stage,section]));
  const headings=[],seen=new Set();
  for(let i=0;i<draft.passages.length;i++){
    const stage=draft.passages[i].section;
    if(!names[stage]||seen.has(stage))continue;
    seen.add(stage);
    const section=provided.get(stage);
    const title=typeof section?.title==='string'&&section.title.trim()
      ?section.title.trim().slice(0,80):names[stage];
    headings.push({
      id:id(),title,beforeIndex:offset+i,
      ...(typeof section?.reason==='string'&&section.reason.trim()
        ?{editorialReason:section.reason.trim().slice(0,240)}:{})
    });
  }
  return headings.filter(heading=>heading.beforeIndex<offset+blocks.length);
}

/** Drag a heading into a gap before passage `beforeIndex`.
 * Only section slots change; never reorder blocks or their source timing. */
export function placeStorySection(paper,id,beforeIndex){
 const headings=paper.sectionHeadings||[];
 const selected=headings.find(section=>section.id===id);
 if(!selected)return paper;
 const nextSlot=slot(paper,beforeIndex);
 if(selected.beforeIndex===nextSlot &&
    headings.indexOf(selected)===headings.length-1)return paper;
 return {...paper,sectionHeadings:[
  ...headings.filter(section=>section.id!==id),
  {...selected,beforeIndex:nextSlot}
 ]};
}
/** Drop a heading immediately before or after another heading.
 * Supports multiple headings occupying the same slot in a stable order. */
export function placeStorySectionBeside(paper,id,targetId,after=false){
 const headings=paper.sectionHeadings||[];
 const selected=headings.find(section=>section.id===id);
 const target=headings.find(section=>section.id===targetId);
 if(!selected||!target||id===targetId)return paper;
 const others=headings.filter(section=>section.id!==id);
 const targetIndex=others.findIndex(section=>section.id===targetId);
 others.splice(targetIndex+(after?1:0),0,{...selected,beforeIndex:slot(paper,target.beforeIndex)});
 if(others.every((section,i)=>section.id===headings[i]?.id && section.beforeIndex===headings[i]?.beforeIndex))return paper;
 return {...paper,sectionHeadings:others};
}
